interface SlugifyOptions {
  encode?: boolean;
  fallback?: string;
}

export const slugify = (text?: string, options: SlugifyOptions = {}): string => {
  const { encode = false, fallback = '-' } = options;

  if (!text) return fallback;

  const slugified = text
    .toString()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .trim()
    .replace(/\./g, '')
    .replace(/'/g, '')
    .replace(/[^a-z0-9\s-]/g, '-')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');

  return encode ? encodeURIComponent(slugified) : slugified;
};
